import React, { useContext } from 'react';

import { FlexDiv, Headings, ResponsiveContainer, GenericDiv } from 'commonStyles';
import { FaqWrapper } from './faqStyles';
import { BorderWrap } from '../../Styles';

import { faqData } from '../../config';
import { isMobileContext } from 'UtilityComponents/Util';
import DisplayContext from 'UtilityComponents/displayContext';
import ActionButtons from '../../../../bizLanding/components/actionButtons/actionButtons';
import { LANDING_CONSTS, PATHS } from 'AppConstants';
import FaqItem from './faqItem';

const FeatureComp = ({ isLoggedInUser }) => {
	const { heading: headTxt, faqList } = faqData;
	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = isMobileContext(displayName);
	return (
		<FaqWrapper itemScope itemType={`${PATHS.SEO_SCHEMA_URL}/FAQPage`}>
			<ResponsiveContainer>
				<BorderWrap />
				<Headings as={isMobile ? 'h3' : 'h1'} dangerouslySetInnerHTML={{ __html: headTxt }} />
				<GenericDiv top_M='40'>
					{faqList.map((faq) => (
						<FaqItem key={faq.index} data={faq} />
					))}
				</GenericDiv>
				<FlexDiv top_M={isMobile ? '38' : '67'} align='center' $direction='column' directionInMobile='column'>
					<Headings as={isMobile ? 'h4' : 'h2'} color='#000'>
						Your business is traveling places. We’re ready to help you save!
					</Headings>
					<GenericDiv $width={isMobile ? '100%' : '300px'} top_M='24'>
						<ActionButtons show={LANDING_CONSTS.SIGNUP} signupTxt={isLoggedInUser ? 'GET STARTED' : 'SIGN UP NOW'} />
					</GenericDiv>
				</FlexDiv>
			</ResponsiveContainer>
		</FaqWrapper>
	);
};

export default FeatureComp;
